import React from "react";
import { Container } from "react-bootstrap";

const First = () => {
  return (
    <>
      <section className="first-webDevelopment-section">
        <Container>
          <div className="page-title text-center">
            <h1>UI/UX Design</h1>
            <div className="sub-info">
              <h3 className="h3">
                Design is our way of Augmenting User Experiences.
              </h3>
              <p>
                At Codeffi, we take UI/UX plans to a place of flawlessness, by
                treating each step of the cycle with equivalent significance.
              </p>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default First;
